export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14040.abae99b3.jpg";